import { render } from "./text-input.vue?vue&type=template&id=67bee91a"
import script from "./text-input.vue?vue&type=script&lang=js"
export * from "./text-input.vue?vue&type=script&lang=js"

import "./text-input.vue?vue&type=style&index=0&id=67bee91a&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script